export const builderTypeSelector = ({ workspaceConfig }) =>
  workspaceConfig.builderType

export const projectSupportSelector = ({ workspaceConfig }) =>
  workspaceConfig.projectSupport
